import { isObservableArray } from 'mobx';

const observableArrayProp = (props, propName, componentName) => {
	if (!isObservableArray(props[propName])) {
		return new Error(
			'Property `' + propName + '` on component `' + componentName + '` is not an observable array. Validation failed.'
		);
	}
};

export default observableArrayProp;
